import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"icon-warning\"><path d=\"m8 2.66 5.02 8.673H2.98zM8 0 .667 12.667h14.666zm.667 9.333H7.333v1.334h1.334zm0-4H7.333V8h1.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol